/**
 * Returns an array of numbers having the `currentPage` number in the middle with
 * a maximum of 9 numbers, so 4 smaller numbers to the left and 4 higher numbers
 * to the right sorted. e.g if `currentPage = 9` should return `[5, 6, 7, 8, 9, 10, 11, 12, 13]`.
 * Can't add numbers to the left smaller than `1` and numbers to the right higher than `maxPages`.
 *
 * @param {number} currentPage - current page selected
 * @param {number} maxPages - max number of pages
 * @param {number} maxOptions - max amount of pagination options
 *
 * @returns {Array}
 */
export const calculatePages = (currentPage, maxPages, maxOptions) => {
  if (maxPages === 0) return [];
  let arr = [currentPage];
  let i = 1;

  while (arr.length !== maxPages && arr.length !== maxOptions) {

    if (currentPage + i <= maxPages) {
      arr.push(currentPage + i);
    }

    if (currentPage - i >= 1) {
      arr.unshift(currentPage - i);
    }

    i++;
  }
  return arr;
};
